
import api from './api';

const headquarterService = {
  // Create headquarter
  createHeadquarter: async (hqData) => {
    try {
      const response = await api.post('/headquarters', hqData);
      return response.data;
    } catch (error) {
      console.error('Error creating headquarter:', error);
      throw error;
    }
  },

  // Get all headquarters (paginated)
  getHeadquarters: async (companyId, page = 1, limit = 10, search = '') => {
    try {
      const params = { page, limit };
      if (search) params.search = search;
      if (companyId) params.companyId = companyId;

      const response = await api.get('/headquarters', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching headquarters:', error);
      throw error;
    }
  },

  // Get headquarters by region (for dropdowns)
  getHeadquartersByRegion: async (regionId) => {
    try {
      const response = await api.get(`/headquarters/region/${regionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching headquarters by region:', error);
      throw error;
    }
  },

  // Get headquarter by ID
  getHeadquarterById: async (id) => {
    try {
      if (!id) throw new Error("ID is required to fetch headquarter");
      const response = await api.get(`/headquarters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching headquarter:', error);
      throw error;
    }
  },


 updateHeadquarter: async (id, hqData) => {
  try {
    const response = await api.post(`/headquarters/${id}`, hqData);
    return response.data;
  } catch (error) {
    // Agar response HTML hai, toh ise console mein print karo
    if (error.response && typeof error.response.data === 'string') {
      console.error("Server returned HTML instead of JSON. Check URL or Permissions.");
    }
    throw error;
  }
},

  // Delete headquarter
  deleteHeadquarter: async (id) => {
    try {
      if (!id) throw new Error("ID is required for delete");
      const response = await api.delete(`/headquarters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting headquarter:', error);
      throw error;
    }
  },

    getAllRegions: async (companyId = null) => {
    const params = {};
    if (companyId) params.companyId = companyId;
    const res = await api.get('/regions/all', { params });
    return res.data;
  },
};

export default headquarterService;